import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../api/client";
import { fetchOutdatedApk, type OutdatedApkRow } from "../api/admin";

/**
 * Phase 7 Plan 03 / D-164 — PM web Outdated APK admin tile hook.
 *
 * Mirrors useQueueHealth.ts shape verbatim:
 *   staleTime: 0 + refetchInterval: 30s = the dedicated dashboard view re-polls
 *   every 30 seconds so PM sees the latest worker app_version state. Per D-173
 *   (no new transports) — TanStack Query refetchInterval is the only mechanism
 *   used for admin tile freshness.
 */
export const OUTDATED_APK_KEY = ["outdated-apk"] as const;

export function useOutdatedApk() {
  return useQuery<OutdatedApkRow[], ApiError>({
    queryKey: OUTDATED_APK_KEY,
    queryFn: fetchOutdatedApk,
    staleTime: 0,
    refetchInterval: 30_000,
    refetchOnWindowFocus: false,
  });
}
